module.exports = __webpack_public_path__ + "static/zhaopin-bdf6225ca5d1d0745c6923207967b94d.png";